const MAX_SNIPPET_LENGTH = 500;

const truncate = (value = '', maxLength = MAX_SNIPPET_LENGTH) =>
  value.length > maxLength ? `${value.slice(0, maxLength)}…` : value;

// Thrown when a streaming request receives a non-2xx response (e.g. a gateway 502 HTML page).
export class ApiStreamError extends Error {
  constructor(message, { status, statusText, url, body } = {}) {
    super(message);
    this.name = 'ApiStreamError';
    this.status = status;
    this.statusText = statusText;
    this.url = url;
    this.body = body;
  }

  static async fromResponse(response) {
    let body = '';
    try {
      body = truncate(await response.text());
    } catch {
      // The body is only used for diagnostics.
    }

    return new ApiStreamError(`Request failed with status ${response.status}`, {
      status: response.status,
      statusText: response.statusText,
      url: response.url,
      body,
    });
  }
}

// Thrown when a line of an NDJSON payload is not valid JSON (including a truncated last line).
export class NdjsonParseError extends Error {
  constructor(lineNumber, line, cause) {
    super(`Invalid NDJSON at line ${lineNumber}: ${cause?.message || 'unparsable JSON'}`);
    this.name = 'NdjsonParseError';
    this.lineNumber = lineNumber;
    this.line = truncate(line, 200);
    this.cause = cause;
  }
}
